import React from "react";

const TextArea = ({ name, label, error, req, icon, ...rest }) => {
  return (
    <div className={`form-group ${req && "required"}`}>
      {label && (
        <label className="form-control-label" htmlFor={name}>
          {icon && <i className={`fa ${icon}`} style={{ marginRight: '6px' }} />}
          {label}
        </label>
      )}
      <div className={icon ? "wf-input-wrap" : ""}>
        {icon && <i className={`fa ${icon} wf-input-icon`} aria-hidden="true" style={{ top: '15px', transform: 'none' }} />}
        <textarea
          {...rest}
          id={name}
          name={name}
          className={`form-control ${icon ? "wf-input-withicon" : ""}`}
          placeholder={label}
        />
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default TextArea;
